import NnKeyConstants from './NnKeyConstants';
import NnAudioElement from './NnAudioElement';

// Each instance of Note is an object with properties to represent pitch, duration, and associated song lyric.
class Note {
  // Create a new note object given a string like "``C#/4" or "D`/16"
  constructor(octaveNoteAndTimingString, lyric) {
    this.parse(octaveNoteAndTimingString || 'R/4');
    this.lyric = lyric || '';
    this.audio = NnAudioElement.getAudioElement(this.octave, this.name);
  }
  // locate the audio DOM element for this note and play it
  play() {
    if (this.isRest) {
      return;
    }
    if (this.audio) {
      console.log('play ' + this.display);
      this.audio.play();
    } else {
      console.log('bad key/audio: ', this.raw);
    }
  }

  startPlay() {
    if (!this.isRest) {
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.loop = false; // make this true to play not continuously until playStop()
      this.audio.play();
    }
  }

  stopPlay() {
    if (!this.isRest) {
      this.audio.pause();
      this.audio.loop = false;
      this.audio.currentTime = 0;
    }
  }

  // calculate the duration of a note
  // timeSignatureDenominator - e.g. 4 signifies a quarter note per beat, 2 a half note, etc.
  // so a quarter note like "C/4" in tempo of 60 bpm and 4/4 time would return 60000 msec.
  // examples:
  // tempo==60, time=="4/4", "C/4" => 60000
  // tempo==60, time=="4/4", "C/2" => 120000
  // tempo==120, time=="4/4", "C/4" => 30000
  // TODO handle dotted and tied notes
  getDurationInMsec(beatDurationInMsec, timeSignatureDenominator) {
    return (beatDurationInMsec * timeSignatureDenominator) / this.value;
  }

  /*  Class Methods */

  // play the note indicated:
  //   noteName is one of A, As, B, C, Cs, D, Ds, E, F, Fs, G, Gs
  //   octave is one of 1, 2, 3, 4, 5
  static playNote(noteName, octave) {
    noteName = noteName || 'C';
    octave = octave || 3;
    let ele = NnAudioElement.getAudioElement(noteName, octave);
    ele.play();
  }

  getDisplayName(showLetter) {
    return NnKeyConstants.getDisplayName(this.name, this.octave, showLetter);
  }

  parse(octaveNoteAndTimingString) {
    // Regex pattern: "C#''/16./3" => ["C#''16./3", "", "C", "#", "''", "16", ".", "/3"]
    //             1      2            3      4        5       6      7
    let pattern = /([`']*)([ABCDEFGR])?([b#]?)([`']*)\/([1-9]+)([+.]?)((\/3)?)/;

    this.raw = octaveNoteAndTimingString || ''; // preserve original noteTiming string

    let matchedNote = this.raw.match(pattern); // For example: ["``C#/4", "``", "C", "#", "", "4"]
    if (matchedNote) {
      this.octave = '' + (4 - matchedNote[1].length + matchedNote[4].length); // no tics before or after is octave == 4
      this.isTied = !matchedNote[2];
      this.name = this.isTied ? '' : NnKeyConstants.getKeyName(matchedNote[2] + matchedNote[3]);
      this.value = parseInt(matchedNote[5], 10); // whole==1, half==2, quarter==4, etc  G/4/3  G/4/3  G/4/3
      this.displayDuration = matchedNote[5];
      if (matchedNote[6]) {
        this.value = this.value * 1.5; // dotted note
        this.displayDuration += matchedNote[6];
      }
      if (matchedNote[7]) {
        this.value = (this.value * 2) / 3; // triplet
        this.displayDuration += matchedNote[7];
        this.isDotted = true;
      }
      this.isRest = matchedNote[2] === 'R';
    } else {
      console.log('pattern match failed for note: ' + this.raw);
    }
  }
}
export default Note;
